/* eslint-disable newline-per-chained-call */
import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';

import z from 'zod';

export const variableBehaviorTypeSchema = z.union([
    z.literal('constant'),
    z.literal('timestamp'),
    z.literal('script'),
]);

const baseVarBehaviorSchema = z.object({
    type: variableBehaviorTypeSchema,
});

const constantVarBehaviorSchema = baseVarBehaviorSchema.extend({
    type: z.literal('constant'),
    targetVarId: z.string().min(1),
    value: z.union([ z.string(), z.number() ]).nullable(),
});

export const scriptVarBehaviorSchema = baseVarBehaviorSchema.extend({
    type: z.literal('script'),
});

const timestampVarBehaviorSchema = baseVarBehaviorSchema.extend({
    type: z.literal('timestamp'),
    targetVarId: z.string().min(1),
});
const navToScreenVarBehaviorSchema = baseVarBehaviorSchema.extend({
    type: z.literal('navToScreen'),
});
const nextScreenVarBehaviorSchema = baseVarBehaviorSchema.extend({
    type: z.literal('nextScreen'),
});
const prevScreenVarBehaviorSchema = baseVarBehaviorSchema.extend({
    type: z.literal('prevScreen'),
});
const eventOnlyVarBehaviorSchema = baseVarBehaviorSchema.extend({
    type: z.literal('eventOnly'),
});

const varBehaviorSchema = z.discriminatedUnion('type', [
    scriptVarBehaviorSchema,
    timestampVarBehaviorSchema,
    constantVarBehaviorSchema,
    navToScreenVarBehaviorSchema,
    nextScreenVarBehaviorSchema,
    prevScreenVarBehaviorSchema,
    eventOnlyVarBehaviorSchema,
]);

export const btnCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('btn'),
    attrs: cellCfgAttrsBaseSchema.extend({
        enabled: z.union([ z.string(), z.number() ]),
        label: z.string(),
        color: z.string(),
        fontColor: z.string().default('#000000'),
        variant: z.enum([ 'default', 'outlined', 'plain', 'text', 'icon' ]).catch('default'),
        targetScreenId: z.string().optional(),
        varBehavior: varBehaviorSchema,
        linkedScriptId: z.string().optional(),
        fontSize: z.string().default('14px'),
        // not used in icon style buttons
        borderRadius: z.string().default('4px'),
        appletEventId: z.string().nullable().default(null),
    }),
    modifiers: z.record(z.enum([
        'enabled',
        'label',
        'color',
    ]), z.string().optional()).optional(),
});
